import { useCallback, useEffect, useState, memo } from "react";

// import { useMousePosition } from "@hooks/useMousePosition";
import { useGetSet } from "@api/hooks/queries/useGetSet";
import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import EmptySlider from "@components/cms/EmptySlider/EmptySlider";
import { getPageFolderName } from "@config/cms";
import { useStore } from "@hooks/useZustandProvider";
import Container from "@ui-kit/Container/Container";
import Tag from "@ui-kit/Tags/Tag";
import Tags from "@ui-kit/Tags/Tags";

import { collectionType } from "./datas";
import s from "./PopularBlock.module.scss";

const PopularBlock = ({ settings, data, updateField }) => {
  const { cms, updateCollectionType } = useStore();
  // const { isWidget } = useMousePosition();
  const { isWidgetEditing } = cms.widget;
  const { isWidget } = cms.page;
  const { isEditMode } = cms.uiOptions;
  const { title, collections } = data;

  const { items } = collections[collectionType];

  const { blockType } = settings.common;
  const cursorNotice = "Double click to edit tags";

  const [allItems, setAllItems] = useState([]);

  const handleClickToEdit = useCallback((e) => {
    switch (e.detail) {
      case 2: // double click
        updateCollectionType(e);
    }
  }, []);

  const [getSet] = useGetSet({
    options: {
      fetchPolicy: "no-cache",
    },
    lazy: true,
  });

  useEffect(() => {
    let isActive = true;

    const fetchData = async () => {
      const filteredItems = items.filter((item) => {
        return typeof item.isShow === "boolean" ? item.isShow : true;
      });
      const promises = filteredItems.map((item) => {
        if (item.setId) {
          return getSet({
            variables: {
              id: item.setId,
            },
          }).then((result) => {
            const setPages = result.data.getSet.data.map((page) => ({
              title: page.title,
              link: `/${getPageFolderName()[item.setType]}/${page.slug}`,
            }));
            return setPages;
          });
        }
        return Promise.resolve(item);
      });

      const results = await Promise.all(promises);

      if (isActive) {
        setAllItems(results.flat());
      }
    };

    fetchData();

    return () => {
      isActive = false;
    };
  }, [items, getSet]);

  return (
    <Container className={s.otherRoutes}>
      <Container full={false}>
        <section>
          <BlockTitle
            settings={settings}
            field={{ title }}
            onChange={updateField}
            type={blockType}
          />
          {!!allItems?.length ? (
            <div
              className={s.stopsWrap}
              {...(isEditMode && !(!isWidgetEditing && isWidget)
                ? {
                    "data-cursor-notice": cursorNotice,
                    "data-collection-type": collectionType,
                    onClick: handleClickToEdit,
                  }
                : {})}
            >
              <Tags>
                {allItems.map((item, key) => {
                  return <Tag to={item.link} text={item.title} key={key} />;
                })}
              </Tags>
            </div>
          ) : isEditMode ? (
            <EmptySlider
              cursorNotice={cursorNotice}
              collectionType={collectionType}
              onClick={handleClickToEdit}
            />
          ) : null}
        </section>
      </Container>
    </Container>
  );
};

export default memo(PopularBlock);
